var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpacexWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 50,
    viewBox: "0 0 400 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 50,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 30.5H10.9V23.9H45.2C44.3 21.1 41.4 18.5 36.3 18.5H11.4C5.7 18.5 2.4 20.6 2.4 25.2V30.1C2.4 34.1 5.8 36.4 10.8 36.4H37.7V43.4H1.5C2.4 47.2 5.3 49.2 10.5 49.2H37.6C43.3 49.2 46.1 47 46.1 42.3V37.4C46.1 33.1 42.8 30.8 37.5 30.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8 18.6H59V49.3H68.3V37.5H92.5C99.2 37.5 102.9 35.2 102.9 29.8V26.4C102.8 21.4 98.6 18.6 91.8 18.6ZM94.8 28.4C94.8 30.6 94.4 31.8 90.8 31.8H68.3L68.4 23.8H90.4C94.4 23.8 94.9 25 94.9 27.1V28.4H94.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.9 17.3L124.3 24.2L133.8 37.3H114L109.1 42.5H137.7L142.6 49.3H153.6L129.9 17.3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.4 23.9H206.2C205.3 20.3 201.8 18.5 196.8 18.5H170.8C166.3 18.5 162 20.3 162 25.2V42.4C162 47.3 166.3 49.1 170.8 49.1H197.1C203.1 49.1 205.2 47.4 206.2 43.3H171.4V23.9V23.9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228.3 43.5V34.1H247V28.9H218.9V49.3H260.4V43.5H228.3Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M261.8 18.6H219.9V24H261.8V18.6Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M287.6 18.6H273L290.2 31.2C292.7 29.5 295.6 27.7 298.2 26.2L287.6 18.6Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.8 34.3C306.3 36 303.8 37.9 301.4 39.7L314.4 49.2H329.1L308.8 34.3Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M399 0.699997C319 5.3 282 39.5 273.7 47.6L272 49.2H286.8C326.8 9.1 384.3 2 399 0.699997Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacexWhite);
export default __webpack_public_path__ + "static/media/spacexWhite.d9d1d6562ba46b086a3f67b267e88e4e.svg";
export { ForwardRef as ReactComponent };